/**
 * الجهةُ المطوِّرة («Powered by») — 27 سبتمبر 2026، وبقرار 28 سبتمبر **اسمٌ بلا شعار**.
 *
 * برشومي لحلول البرمجيات (Barshumi Software Solutions) — https://www.barshumi.site/ (A-117، أُغلق).
 * وبطلب صاحب المنصة (29 سبتمبر 2026): **كلمةُ «BARSHUMI» كما في شعارها** بلا الرمز — قناعٌ مقصوصٌ من
 * `docs/brand/logo-barshumi-full.png` (`.review/barshumi-wordmark.mjs`) يُلوَّن بـ`currentColor` فيأخذ لونَ
 * «Powered by» نفسَه. ما دام `url` فارغاً يبقى السطرُ بلا رابط.
 */
export interface PoweredByInfo {
  nameAr: string | null;
  nameEn: string | null;
  /** رابطُ الجهة — https فقط، يُفتح في تبويبٍ جديد */
  url: string | null;
  /** كلمةُ الشعار قناعاً في `public/brand/` — بلا قيمةٍ يُعرض الاسمُ نصّاً */
  wordmark?: boolean;
}

export const POWERED_BY: PoweredByInfo = {
  nameAr: 'برشومي',
  nameEn: 'Barshumi',
  url: 'https://www.barshumi.site/',
  wordmark: true,
};
